import React, { Component } from 'react';
import { Table, Modal, Button } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class ApprovalHistory extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    loadData = () => {
        const { record: { jdeMainApplyId } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.queryJdeMainApplyApprovalHistory,
            data: { jdeMainApplyId },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    data: res.data,
                    loading: false,
                })
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => ([
        {
            title: '操作时间',
            dataIndex: 'approvalDate',
            key: 'approvalDate',
            width: 80,
        }, {
            title: '操作人',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 110,
            render: (text, record) => {
                const { employeeCode } = record;
                return `${text}${employeeCode ? `(${employeeCode})` : ''}`;
            }
        }, {
            title: '操作内容',
            dataIndex: 'approvalContent',
            key: 'approvalContent',
            width: 120,
        }, {
            title: '操作结果',
            dataIndex: 'approvalResult',
            key: 'approvalResult',
            width: 120,
        },  {
            title: '拒绝/不通过原因',
            dataIndex: 'comments',
            key: 'comments',
            width: 170,
        }
    ])

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map(item => ({ ...item } ));
        return dataSource;
    }

    render() {
        const { visible, loading, record: { investigationName, jdeMainApplyCode } } = this.state;
        return (
            <Modal
                title="操作日志"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width={900}
                bodyStyle={{ maxHeight: 600 }}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div style={{ marginBottom: 16 }}>
                        申请编号：{jdeMainApplyCode}
                        <span className="ant-divider" />
                        项目简称：{investigationName}
                    </div>
                    <Table
                        bordered
                        loading={loading}
                        pagination={false}
                        scroll={{x: 600, y: 400}}
                        columns={this.getColumns()}
                        dataSource={this.getDataSource()}
                        rowKey={record => record.jdeApplyApprovalHistoryId}
                    />
                    <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                </div>
            </Modal>
        );
    }
}

class ContractAttachment extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
    }
    
    show = record => {
        this.setState({
            record,
            visible: true
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    loadData = () => {
        const { record: { jdeMainApplyId } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'post',
            url: API_URL.contract.queryJdeApplyFileMetaById,
            data: {
                jdeApplyId: jdeMainApplyId,
                uploadType: 'MAIN_CONTRACT',
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    data: res.data,
                    loading: false,
                });
            }
        };
        $.sendRequest(options);
    }

    downLoadFile = (e, id) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({fileMetaId: id}, null, url);
    }

    getColumns = () => [{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 100,
    }, {
        title: '附件名称',
        dataIndex: 'name',
        key: 'name',
        width: 400,
        render: (text, record) => (
            <a onClick={e => this.downLoadFile(e, record.fileMateId)}>{text}</a>
        )
    }]

    getDateSource = () => {
        const { data = [] } = this.state;
        const dataSource = [];

        data.map((item, index) => {
            dataSource.push({
                index: index + 1,
                ...item,
            })
        });

        return dataSource;
    }

    render () {
        const { visible, loading, record: { investigationName } } = this.state;
        return (
            <Modal
                title="查看附件"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="560px"
                footer={<Button type="primary" onClick={this.hide}>关 闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div style={{ marginBottom: 16 }}>
                        项目简称：{investigationName}
                    </div>
                    <div>
                        <Table
                            columns={this.getColumns()}
                            dataSource={this.getDateSource()}
                            rowKey={record => record.index}
                            scroll={{x: 500, y: 270}}
                            pagination={false}
                            loading={loading}
                            bordered
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

export { ApprovalHistory, ContractAttachment };



// WEBPACK FOOTER //
// ./src/components/contractManagement/alterJdeCode/PreviewModal.js